import React,{useState,useCallback} from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';
import {Title, Capacity, Occupied, Vacancy, Change, RealClock} from './components';
import {Row,Col,Card} from 'react-bootstrap/';
import {FaHistory} from "react-icons/fa";
export const BlockX = ({obj}) =>{
	const [state,setState] = useState({occupied:{amount:0,records:[]}, vacancy:{amount:25,records:[]}});
	const handleOccupy = useCallback(()=>{
		let newOccupiedAmount = state.occupied.amount + 1;
		let newOccupiedRecords = [...state.occupied.records];
		newOccupiedRecords.push({amount:newOccupiedAmount, date:moment(new Date()).format('DD/MM/yyyy HH:mm:ss a')});
		let newOccupied = {amount:newOccupiedAmount,records:newOccupiedRecords}

		let newVacancyAmount = state.vacancy.amount - 1;
		let newVacancyRecords = [...state.vacancy.records];
		newVacancyRecords.push({amount:newVacancyAmount, date:moment(new Date()).format('DD/MM/yyyy HH:mm:ss a')});
		let newVacancy = {amount:newVacancyAmount,records:newVacancyRecords}
		setState((prevState)=>{return {
			...prevState, ...{occupied:newOccupied,vacancy:newVacancy}
		}})
	},[state])
	const handleVacate = useCallback(()=>{
		let newOccupiedAmount = state.occupied.amount - 1;
		let newOccupiedRecords = [...state.occupied.records];
		newOccupiedRecords.push({amount:newOccupiedAmount, date:moment(new Date()).format('DD/MM/yyyy HH:mm:ss a')});
		let newOccupied = {amount:newOccupiedAmount,records:newOccupiedRecords}

		let newVacancyAmount = state.vacancy.amount + 1;
		let newVacancyRecords = [...state.vacancy.records];
		newVacancyRecords.push({amount:newVacancyAmount, date:moment(new Date()).format('DD/MM/yyyy HH:mm:ss a')});
		let newVacancy = {amount:newVacancyAmount,records:newVacancyRecords}
		setState((prevState)=>{return {
			...prevState, ...{occupied:newOccupied,vacancy:newVacancy}
		}})
	},[state])
	return(
		<>	
			<Row className="ml-0 mr-0 pl-0 pr-0 col-lg-12 col-md-12 col-sm-12 col-xs-12 pl-0 pr-0 align-self-start justify-content-center">
				<Col xl={12} lg={12} md={12} sm={12} xs={12} className="pl-0 pr-0 fade-in">
					<Card className="text-center">
					<Card.Header className="text-center bg-custom-blue text-left text-white">
						<Title/>
					</Card.Header>
						<span>
						<span style={{fontSize:'4.0rem',lineHeight: '1.3'}}>
							<Capacity amount={25}/><br/>
						</span>
						<span style={{fontSize:'3.5rem',lineHeight: '1.3'}}>
							<FaHistory/> <RealClock/>
						</span>
						<br/><br/>
						<Row className="ml-0 mr-0 mr-0 col-lg-12 col-md-12 col-sm-12 col-xs-12 pl-0 pr-0 align-self-start justify-content-center">
							<Col xl={5} lg={5} md={5} sm={12} xs={12} className="pl-0 pr-0 fade-in" >
								<Occupied occupied={state.occupied}/>
							</Col>
							<Col xl={2} lg={2} md={2} sm={12} xs={12} className="pl-0 pr-0 fade-in" style={{alignSelf: 'center'}}>
								<Change 
									handleOccupy={handleOccupy} 
									handleVacate={handleVacate} 
									canOccupy={state.vacancy.amount > 0} 
									canVacate={state.occupied.amount > 0}
								/>
							</Col>
							<Col xl={5} lg={5} md={5} sm={12} xs={12} className="pl-0 pr-0 fade-in" >
								<Vacancy vacancy={state.vacancy}/>	
							</Col>
						</Row>
						<br/>
						</span>
					</Card>
				</Col>
			</Row>
			
		</>
	)

}
BlockX.propTypes = {
	obj: PropTypes.object
};
